import React from 'react';
import { find } from 'lodash';

export const Switch = (props) => {
  return find(React.Children.toArray(props.children), item => {
    return (!item.props.hasOwnProperty('condition')) || item.props.condition
  }) || null
}

export const Case = ({ children, ...rest }) => {
  return React.isValidElement(children) ?
    children : <div {...rest}>{ children }</div>
}



// WEBPACK FOOTER //
// ./client/components/switch-case.js